import { logger } from './logger';


export const loadableWithRetry = (importFunc) => {
    return async () => {
      try {
        return await importFunc();
      } catch (error) {
        const isChunkLoadError =
          error?.message?.includes("Failed to fetch dynamically imported module") ||
          error?.message?.includes("Loading chunk") ||
          error?.message?.includes("ChunkLoadError");
  
        if (isChunkLoadError) {
            logger.error(isChunkLoadError, 'Import error - force reloading');
            window.location.reload(); // Force a reload to get fresh chunks
        }
  
        throw error;
      }
    };
  };
  